export const animationDefaults = {
	animInClassName    : 'xyz-in',
	xyzDefaultSettings : 'fade perspective-4 down-4 origin-bottom small-3',
	xyzBottomStagger   : 'fade down stagger-2',
	fadeInFast         : 'fade perspective-4 down-4 origin-bottom small-3 duration-0.5'
};
